import { render, staticRenderFns } from "./lawcomponenttw.vue?vue&type=template&id=121f8fea&scoped=true&"
import script from "./lawcomponenttw.vue?vue&type=script&lang=js&"
export * from "./lawcomponenttw.vue?vue&type=script&lang=js&"
import style0 from "./lawcomponenttw.vue?vue&type=style&index=0&id=121f8fea&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "121f8fea",
  null
  
)

export default component.exports